import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserUpdateFailedAction = {
	type: 'USER_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserUpdateFailedAction => ({
	type: 'USER_UPDATE_FAILED',
	payload,
});
